var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[(_vm.fixed)?[_c('div',{staticClass:"x-w-ctn"},[_vm._t("default")],2)]:[_vm._t("default")],_c('div',{staticClass:"menu_wkBox_back_box"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }